import { useCallback, useEffect, useState } from "react";
import apiClient from "../utils/ApiClient/apiClientAxios";

export function useGetCodes(configId) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCodes = useCallback(async () => {
    if (!configId) return;
    setIsLoading(true);
    setError(null);
    try {
      const response = await apiClient.get("/getCodes", {
        params: { id: configId },
      });
      setData(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [configId]);

  useEffect(() => {
    fetchCodes();
  }, [fetchCodes]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchCodes,
  };
}
